initSectionAccordions();
function initSectionAccordions() {
  const sections = document.querySelectorAll(".sc-accordions");

  for (const section of sections) {
    const json = section.querySelector(".json");
    if (!json) continue;
    const json_data = JSON.parse(json.innerHTML);

    // Wrap all instances of the word
    for (const item of json_data) {
      const id = item.text;

      section.innerHTML = section.innerHTML.replaceAll(
        id,
        `<button class="highlight underline" tooltip-highlight ${
          item.explainer ? `data-tippy-content="${item.explainer}"` : ""
        }>
          <span>${item.text}</span>
        </button>`
      );
    }
  }
}
